import { APIService } from "../../../../network/api/APIService";


export const GenerateOTP = (formData) => {
  return APIService({
      endpoint: "/authentication/otp/",
      method: "POST",
      data: formData
  });
};